import React, { useState, useEffect, useRef } from 'react';
import Demomodal from '../Demomodal/Demomodal';
import styles from '../Header/Navbar.module.css';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import style from './Navbar.module.css';

export default function Navbar() {
    const [isDemoModalOpen, setIsDemoModalOpen] = useState(false);
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const navbarRef = useRef(null); // Reference for the navbar

    const toggleDemoModal = () => {
        setIsDemoModalOpen(!isDemoModalOpen);
    };

    const toggleNavbar = () => {
        setIsNavbarOpen(!isNavbarOpen);
    };

    const closeNavbar = () => {
        setIsNavbarOpen(false);
    };

    const navigate = useNavigate();

    const scrollToSection = (sectionId) => {
        setTimeout(() => {
            const section = document.getElementById(sectionId);
            if (section) {
                window.scrollTo({
                    top: section.offsetTop - 80, // Adjust the offset to match your navbar height
                    behavior: 'smooth',
                });
            }
        }, 10);
    };

    const handleHomeClick = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('HOME_SECTION');
        closeNavbar(); // Close navbar on link click
    };

    const handleAboutUsClick = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('ABOUT_SECTION');
        closeNavbar(); // Close navbar on link click
    };

    const handleContactUsClick = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('Contact_Us');
        closeNavbar(); // Close navbar on link click
    };

    const handleServicesClick = (e) => {
        e.preventDefault();
        navigate('/');
        scrollToSection('Service_s');
        closeNavbar(); // Close navbar on link click

    };



    useEffect(() => {
        const handleClickOutside = (event) => {
            if (navbarRef.current && !navbarRef.current.contains(event.target)) {
                closeNavbar(); // Close navbar if click is outside
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    return (
        <>
            <nav className={`navbar navbar-expand-lg  ${styles.mainNavbar}`} ref={navbarRef}>
                <div className="container">
                    <a className={`${styles.navHeading} navbar-brand`} href="/">
                        <img src="/images/logo.png" alt="" />
                    </a>
                    <button
                        className={`${styles.navbartogglericon} navbar-toggler`}
                        type="button"
                        onClick={toggleNavbar}
                        aria-expanded={isNavbarOpen}
                        aria-label="Toggle navigation"
                    >
                        <i class="fa-solid fa-bars"></i>
                    </button>
                    <div className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`} id="navbarContent">
                        <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                            <li className="nav-item">
                                <a className={`nav-link ${styles.navLink}`} href="/home" onClick={handleHomeClick}>
                                    Home
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link ${styles.navLink}`} href="/Aboutus" onClick={handleAboutUsClick}>
                                    About
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link ${styles.navLink}`} href="/Servicespage" onClick={handleServicesClick}>
                                    Services
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link ${styles.navLink}`} href="/Contactus" onClick={handleContactUsClick}>
                                    Contact Us
                                </a>
                            </li>
                        </ul>

                        <div className={styles.navbuttonsdiv}>

                            <button
                                className={`${styles.navButtondemo} ${style.navbuttonhover}`}

                                onClick={() => {
                                    toggleDemoModal(); // Toggles the demo modal
                                    closeNavbar(); // Closes the navbar
                                }}
                            >
                                Book Demo
                            </button>
                            <Link
                                to={"/Log_in"}
                                className={` ${styles.navButton} mx-1`}
                                onClick={() => {

                                    closeNavbar(); // Closes the navbar
                                }}
                            >
                                <i className="fas fa-sign-in-alt"></i> &nbsp; Login
                            </Link>
                        </div>
                    </div>
                </div>
            </nav>
            {isDemoModalOpen && <Demomodal onClose={toggleDemoModal} />}
        </>
    );
}
